
// Auto-generated file: Do not modify directly. Changes may be overwritten. Version: 1.3.0.

/*
* Following tokens have been deprecated in version 1.3.0, please update your theme:
*
* Interactive/Focus has been split into two separate tokens. Please define 'Interactive/Focus Inner' and 'Interactive/Focus Outer' instead.
* 'Interactive/Background Default' is deprecated. Please use 'Input/Background Default' instead.
* 'Interactive/Background Disabled' is deprecated. Please use 'Input/Background Disabled' instead.
* 'Interactive/Background Hovered' is deprecated. Please use 'Input/Background Hovered' instead.
* 'Interactive/Background Pressed' is deprecated. Please use 'Input/Background Pressed' instead.
* 'Interactive/Border Default' is deprecated. Please use 'Input/Border Default' instead.
* 'Interactive/Border Hovered' is deprecated. Please use 'Input/Border Hovered' instead.
* 'Interactive/Border Disabled' is deprecated. Please use 'Input/Border Disabled' instead.
* 'Interactive/Border Critical Default' is deprecated. Please use 'Input/Border Critical' instead.
* 'Pill' is deprecated. Please use 'Circle' instead.
*/


import type { GDSTheme } from '@leagueplatform/genesis-core';

export const cignaHealthTheme: GDSTheme = {
  colors: {
    surface: {
      background: {
        primary: '#E8E7D9FF',
        secondary: '#FFFFFFFF',
        tertiary: '#F5EAF8FF'
      },
      card: {
        primary: '#F4F4F4FF',
        secondary: '#FFFFFFFF',
        disabled: '#D7D7D7FF'
      },
      screenHeader: { background: '#FFFFFFFF' },
      skeleton: {
        shimmer: {
          background: '#E7E7E7FF',
          overlay: 'linear-gradient(90.0deg, #FFFFFF00 0%, #FFFFFF80 50%, #FFFFFFE5 70%, #FFFFFF00 100%)'
        }
      }
    },
    onSurface: {
      text: {
        primary: '#1F1647FF',
        subdued: '#555555FF',
        reversed: '#FFFFFFFF',
        critical: '#BA0000FF',
        success: '#3F7316FF',
        warning: '#C94F08FF'
      },
      border: { subdued: '#D3D5D7FF', default: '#7A7A7AFF', card: '#E0E3E6FF' },
      icon: { primary: '#1F1647FF' }
    },
    interactive: {
      action: {
        primary: '#9E28B5FF',
        hovered: '#7E2091FF',
        pressed: '#5F186DFF',
        subdued: '#333333FF',
        disabled: '#D6D6D6FF'
      },
      icon: { default: '#F4F4F4FF', disabled: '#949494FF' },
      background: {
        default: '#FFFFFFFF',
        disabled: '#E8EAEDFF',
        hovered: '#F8F8F8FF',
        pressed: '#F0F0F0FF'
      },
      border: {
        default: '#949494FF',
        hovered: '#4E4E4EFF',
        disabled: '#D6D6D6FF',
        critical: { default: '#A12127FF' }
      },
      focus: { inner: '#7E2091FF', outer: '#7E2091FF' }
    },
    critical: {
      background: { subdued: '#F9E1E2FF', secondary: '#FFFFFFFF' },
      border: { default: '#BA0000FF' },
      icon: '#BA0000FF'
    },
    warning: {
      background: { subdued: '#FAD6BDFF', secondary: '#FFFFFFFF' },
      border: { default: '#C94F08FF' },
      icon: '#C94F08FF'
    },
    success: {
      background: { subdued: '#F6FCEBFF', secondary: '#FFFFFFFF' },
      border: { default: '#507C03FF' },
      icon: '#507C03FF'
    },
    highlight: {
      background: { subdued: '#EDF8FFFF', secondary: '#FFFFFFFF' },
      border: { default: '#2E5CDFFF' },
      icon: '#2E5CDFFF'
    },
    decorative: {
      brand: {
        primary: {
          darkest: '#5F186DFF',
          dark: '#7E2091FF',
          default: '#9E28B5FF',
          bright: '#B153C4FF',
          brightest: '#D8A9E1FF',
          pastel: '#F5EAF8FF'
        },
        secondary: {
          darkest: '#130D2BFF',
          dark: '#191239FF',
          default: '#1F1647FF',
          bright: '#4C456CFF',
          brightest: '#A5A2B5FF',
          pastel: '#E9E8EDFF'
        },
        tertiary: {
          darkest: '#003F22FF',
          dark: '#00542DFF',
          default: '#006938FF',
          bright: '#338760FF',
          brightest: '#99C3AFFF',
          pastel: '#E6F0EBFF'
        }
      }
    },
    primary: {
      background: {
        default: '#9E28B5FF',
        hovered: '#7E2091FF',
        pressed: '#5F186DFF',
        critical: {
          default: '#BA0000FF',
          hovered: '#B51414FF',
          pressed: '#BA0000FF'
        }
      },
      text: { default: '#FFFFFFFF', critical: { default: '#FFFFFFFF' } }
    },
    secondary: {
      background: {
        default: '#F0F0F0FF',
        hovered: '#F5EAF8FF',
        pressed: '#F0F0F0FF'
      },
      text: { default: '#9E28B5FF', hovered: '#FFFFFFFF' },
      border: { default: '#9E28B5FF' }
    },
    tertiary: {
      background: {
        default: '#F0F0F0FF',
        hovered: '#F5EAF8FF',
        pressed: '#F0F0F0FF'
      },
      text: { default: '#9E28B5FF', hovered: '#FFFFFFFF' },
      border: { default: '#707E89FF' }
    },
    input: {
      border: {
        success: '#3F7316FF',
        warning: '#C94F08FF',
        default: '#949494FF',
        hovered: '#4E4E4EFF',
        disabled: '#D6D6D6FF',
        critical: '#A12127FF'
      },
      background: {
        default: '#FFFFFFFF',
        disabled: '#E8EAEDFF',
        hovered: '#F8F8F8FF',
        pressed: '#F0F0F0FF'
      }
    },
    dataViz: {
      interface: { track: { border: '#959595FF', background: '#F5F5F5FF' } },
      singleColor: { brand: '#9E28B5FF', neutral: '#959595FF' },
      status: {
        critical: '#BA0000FF',
        warning: '#C94F08FF',
        success: '#3F7316FF'
      },
      categorical: {
        one: '#1A1A1AFF',
        two: '#9E28B5FF',
        three: '#BA0000FF',
        four: '#2695E6FF',
        five: '#C94F08FF',
        six: '#3F7316FF'
      }
    },
    tag: {
      neutral: {
        background: { bold: '#3B3B3BFF', subdued: '#E9E9E9FF' },
        border: { bold: '#3B3B3BFF', subdued: '#E9E9E9FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' }
      },
      one: {
        background: { bold: '#9E28B5FF', subdued: '#F5EAF8FF' },
        border: { bold: '#9E28B5FF', subdued: '#F5EAF8FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' }
      },
      two: {
        background: { bold: '#135D03FF', subdued: '#DEEADCFF' },
        border: { bold: '#135D03FF', subdued: '#DEEADCFF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' }
      },
      three: {
        background: { bold: '#994000FF', subdued: '#F2EEE6FF' },
        border: { bold: '#994000FF', subdued: '#F2EEE6FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' }
      },
      four: {
        background: { bold: '#870644FF', subdued: '#F2E1F0FF' },
        border: { bold: '#870644FF', subdued: '#F2E1F0FF' },
        text: { bold: '#FFFFFFFF', subdued: '#1A1A1AFF' }
      },
      success: {
        background: { bold: '#3F7316FF', subdued: '#E3F7F0FF' },
        border: { bold: '#3F7316FF', subdued: '#E3F7F0FF' },
        text: { bold: '#FFFFFFFF', subdued: '#3F7316FF' }
      },
      warning: {
        background: { bold: '#C94F08FF', subdued: '#FAE8D6FF' },
        border: { bold: '#C94F08FF', subdued: '#FAE8D6FF' },
        text: { bold: '#FFFFFFFF', subdued: '#C94F08FF' }
      },
      critical: {
        background: { bold: '#BA0000FF', subdued: '#F9E1E2FF' },
        border: { bold: '#BA0000FF', subdued: '#F9E1E2FF' },
        text: { bold: '#FFFFFFFF', subdued: '#BB1111FF' }
      },
      informational: {
        background: { bold: '#2E5CDFFF', subdued: '#E8F8FFFF' },
        border: { bold: '#2E5CDFFF', subdued: '#E8F8FFFF' },
        text: { bold: '#FFFFFFFF', subdued: '#225ECEFF' }
      }
    }
  },
  shadows: {
    card: { x: 0, y: 2, blur: 6, spread: 0, color: '#0000000A' },
    dropdown: { x: 0, y: 4, blur: 8, spread: 0, color: '#0000001A' }
  },
  typography: {
    headingOne: {
      fontFamily: "Halyard, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 40,
      fontSize: 32,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none'
    },
    headingTwo: {
      fontFamily: "Halyard, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 32,
      fontSize: 24,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none'
    },
    headingThree: {
      fontFamily: "Halyard, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 28,
      fontSize: 20,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none'
    },
    headingFour: {
      fontFamily: "Halyard, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 500,
      lineHeight: 24,
      fontSize: 18,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none'
    },
    subtitleOne: {
      fontFamily: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none'
    },
    subtitleTwo: {
      fontFamily: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none'
    },
    bodyOne: {
      fontFamily: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none'
    },
    bodyOneSecondary: {
      fontFamily: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none'
    },
    bodyTwo: {
      fontFamily: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none'
    },
    bodyTwoSecondary: {
      fontFamily: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: 0,
      paragraphSpacing: 8,
      textCase: 'none',
      textDecoration: 'none'
    },
    buttonOne: {
      fontFamily: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 24,
      fontSize: 16,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none'
    },
    buttonTwo: {
      fontFamily: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 20,
      fontSize: 14,
      letterSpacing: -0.20000000298023224,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none'
    },
    label: {
      fontFamily: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none'
    },
    overline: {
      fontFamily: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 700,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0.6000000238418579,
      paragraphSpacing: 0,
      textCase: 'uppercase',
      textDecoration: 'none'
    },
    caption: {
      fontFamily: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 16,
      fontSize: 12,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none'
    },
    tab: {
      fontFamily: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
      fontWeight: 400,
      lineHeight: 12,
      fontSize: 10,
      letterSpacing: 0,
      paragraphSpacing: 0,
      textCase: 'none',
      textDecoration: 'none'
    }
  },
  spacing: {
    none: 0,
    quarter: 4,
    half: 8,
    threeQuarters: 12,
    one: 16,
    oneAndHalf: 24,
    two: 32,
    twoAndHalf: 40,
    three: 48,
    four: 64,
    five: 80,
    eighth: 2
  },
  borderWidths: { thin: 1, thick: 2, outerFocus: 3, innerFocus: 3, card: 1 },
  borderRadii: {
    none: 0,
    thin: 1,
    thick: 2,
    small: 3,
    medium: 6,
    large: 9,
    extraLarge: 12,
    huge: 20,
    circle: 99999,
    pill: 99999,
    button: 99999,
    inputField: 6,
    card: 6,
    progressBar: 9999,
    tags: 4
  },
  zIndices: {
    default: 1,
    sticky: 100,
    dropdown: 4000,
    tooltip: 5000,
    modal: 8000,
    toast: 9000
  },
  rem: {
    fontSizes: {
      headingOne: 2,
      headingTwo: 1.5,
      headingThree: 1.25,
      headingFour: 1.125,
      subtitleOne: 1,
      subtitleTwo: 0.875,
      bodyOne: 1,
      bodyOneSecondary: 1,
      bodyTwo: 0.875,
      bodyTwoSecondary: 0.875,
      buttonOne: 1,
      buttonTwo: 0.875,
      label: 0.75,
      overline: 0.75,
      caption: 0.75,
      tab: 0.625
    },
    lineHeights: {
      headingOne: 2.5,
      headingTwo: 2,
      headingThree: 1.75,
      headingFour: 1.5,
      subtitleOne: 1.5,
      subtitleTwo: 1.25,
      bodyOne: 1.5,
      bodyOneSecondary: 1.5,
      bodyTwo: 1.25,
      bodyTwoSecondary: 1.25,
      buttonOne: 1.5,
      buttonTwo: 1.25,
      label: 1,
      overline: 1,
      caption: 1,
      tab: 0.75
    },
    baseSize: 16
  },
  fonts: {
    headings: "Halyard, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    body: "Source Sans Pro, BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
  },
  transitions: { defaultTime: '200ms' }
}
  